import { render, staticRenderFns } from "./EntriesTable.vue?vue&type=template&id=54ab7548&"
import script from "./EntriesTable.vue?vue&type=script&lang=js&"
export * from "./EntriesTable.vue?vue&type=script&lang=js&"
import style0 from "./EntriesTable.vue?vue&type=style&index=0&id=54ab7548&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports